import { Card, CardContent } from "@/components/ui/card";

export default function SignaturesTab({ signatures }) {
  return (
    <Card className="mt-4 border-black/5">
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="admin-signatures-table">
          <thead className="bg-[color:var(--bg-secondary)] text-left">
            <tr><th className="p-3">Member</th><th className="p-3">Form</th><th className="p-3">Signed At</th><th className="p-3">IP</th></tr>
          </thead>
          <tbody>
            {signatures.map((s) => (
              <tr key={s.signature_id} className="border-t border-black/5">
                <td className="p-3">{s.email}</td>
                <td className="p-3">{s.form_label || s.form_type}</td>
                <td className="p-3">{new Date(s.signed_at).toLocaleString()}</td>
                <td className="p-3 text-xs">{s.ip}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {signatures.length === 0 && <p className="p-4 text-sm text-[color:var(--text-secondary)]">No signatures yet.</p>}
      </CardContent>
    </Card>
  );
}
